
import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p380144077566414848',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})

